import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, TextField, Button, FormControlLabel, Switch, CircularProgress, ListItem, ListItemText, Divider, List, } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import CheckIcon from '@material-ui/icons/Check';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import DeleteIcon from '@material-ui/icons/Delete';
import CustomBreadcrumbs from '../Breadcrumb';
import { AddBDNotes, getBreakdownDetails, } from '../../ReduxStore/Breakdown/BreakdownSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library'
import { convertUTCtoIST } from '../../helpers/DateConvert';




const AddNotes = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
        { label: 'Pending Notes', href: '/breakdown-management/pending-notes' },
    ];
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const breakdown_id = pathname[4];

    const [loading, setLoading] = useState(true);
    const [postLoading, setPostLoading] = useState(false);
    const [breakDownDetails, setBreakdownDetails] = useState();

    const [checkpoints, setCheckpoints] = useState([{ type: '', name: '', value: '' }]);
    const [rootCause, setrootCause] = useState(false);
    const Role = localStorage.getItem("userRole");


    const submitHandler = async () => {
        if (Role === 'admin' || Role === 'supplier') {
            const payload = {
                machine_breakdown_id: breakdown_id,
                customer_id: "af33f9117ecb4d8d8def84d6331eebd4",
                status_id: rootCause ? "4a3b66d635254102b5f45f4212e180a4" : "fbb69d283f8c4f61a1a6acc42c65d3c9",
                notes: {
                    "other_fields": "other_fields"
                },
            }
            try {
                setPostLoading(true)
                const action = dispatch(AddBDNotes(payload));
                const res = await action.unwrap();
                console.log("res", res.result)
                if (res.StatusCode === 201) {
                    setPostLoading(false)
                    toast.success("BreakDown Approved Successfully!");
                    setTimeout(() => {
                        navigate("/breakdown-management");
                    }, 2000);
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
            }
        } else {
            toast.info("You don't allow to do this activity!")
        }


    }


    const addRow = () => {
        setCheckpoints([...checkpoints, { type: '', name: '', value: '' }]);
    };

    const handleChange = (index, field, value) => {
        const updatedCheckpoints = checkpoints.map((checkpoint, i) => (
            i === index ? { ...checkpoint, [field]: value } : checkpoint
        ));
        setCheckpoints(updatedCheckpoints);
    };

    const handleDelete = (index) => {
        setCheckpoints(checkpoints.filter((_, i) => i !== index));
    };

    const getbreakdownDetails = async () => {
        try {
            const action = dispatch(getBreakdownDetails(breakdown_id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setBreakdownDetails(res.result.breakdown)
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            await getbreakdownDetails();
            setLoading(false);
        };
        fetchData();
    }, [])



    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }




    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Add Notes" />
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Asset no.
                            <h4>{(breakDownDetails.machine_details.asset_no)?.slice(3)}</h4>
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            Asset Description
                            <h4>{breakDownDetails.machine_details.asset_text}</h4>
                        </Grid>
                        {/* <Grid item xs={6} sm={2}>
                            RFID NO
                            <h4>{breakDownDetails.machine_details?.rfidNo || "NA"}</h4>
                        </Grid> */}
                        <Grid item xs={6} sm={3}>
                            Part No
                            <h4>{breakDownDetails.machine_details?.material_no || "NA"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Priority
                            <h4>{breakDownDetails.priority}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={3}>
                            Nature
                            <h4>{breakDownDetails.reason.category_name}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Failure Reason
                            <h4>{breakDownDetails.reason.name}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={6} sm={2}>
                            Assigned by
                            <h4>{breakDownDetails.status_history[0].status_change_username}</h4>
                        </Grid> */}
                        {Object.keys(breakDownDetails.comments)
                            .filter(commentId => commentId !== 'user_names') // Filter out 'user_names'
                            .map((commentId) => {
                                const commentData = breakDownDetails.comments[commentId];
                                const userName = breakDownDetails.comments.user_names[commentId];
                                // Split the timestamp and comment
                                const [timestamp] = commentData.split(': ');

                                // Format the date using dayjs
                                // const formattedDate = dayjs(timestamp).format("DD MMM, YYYY hh:mm A");

                                return (
                                    <>
                                        <Grid item xs={6} sm={3} key={commentId}>
                                            Assigned by
                                            <h4>{userName}</h4>
                                        </Grid>
                                        <Grid item xs={6} sm={3} key={commentId}>
                                            Assigned at
                                            {/* <h4>{formattedDate}</h4> */}
                                            <h4>{convertUTCtoIST(timestamp)}</h4>
                                        </Grid>
                                    </>
                                );
                            })
                        }

                        {/* <Grid item xs={6} sm={2}>
                            Assigned at
                            <h4>{new Date(breakDownDetails.status_history[0].status_change_timestamp).toLocaleString()}</h4>
                        </Grid> */}
                        <Grid item xs={6} sm={3}>
                            Attended by
                            <h4>{breakDownDetails.attendance[0].attended_username}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Attended at
                            {/* <h4>{dayjs(breakDownDetails.attendance[0].attended_timestamp).format("DD MMM, YYYY hh:mm A")}</h4> */}
                            <h4>{convertUTCtoIST(breakDownDetails.attendance[0].attended_timestamp)}</h4>
                        </Grid>
                    </Grid>

                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Breakdown Title"
                                name="breakdowntitle"
                                type="text"
                                value={breakDownDetails.name}
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Problem observed"
                                name="problemObserved"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Diagnosis"
                                name="diagnosis"
                                type="text"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Box>
                {/* <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={3}>
                        <Grid item>
                            <p>Tools used</p>
                        </Grid>
                        <Grid item xs={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={addRow}>
                                Add Row
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} alignItems='center'>
                        <Grid item xs={2}>
                            <h4>Sr.no</h4>
                        </Grid>
                        <Grid item xs={5}>
                            <h4>Tools</h4>
                        </Grid>
                        <Grid item xs={2}>
                            <h4>Action</h4>
                        </Grid>
                    </Grid>
                    <hr />
                    {checkpoints.map((checkpoint, index) => (
                        <Grid container spacing={3} alignItems='center' key={index}>
                            <Grid item xs={2}>
                                {index + 1}
                            </Grid>
                            <Grid item xs={5}>
                                <TextField
                                    label="Select Tool"
                                    name="name"
                                    type="text"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={checkpoint.name}
                                    onChange={(e) => handleChange(index, 'name', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={2} >
                                <DeleteIcon style={{ color: "red" }} onClick={() => handleDelete(index)} />
                            </Grid>
                        </Grid>
                    ))}
                    <hr />
                </Box> */}
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5}>
                            Added observations
                            {/* <h4>{breakDownDetails.date}</h4> */}
                            {breakDownDetails && breakDownDetails.attendance.length > 0 && (
                                <List>
                                    {breakDownDetails.attendance.map((attend, index) => {
                                        const timestamp = dayjs(attend.attended_timestamp).format('DD MMM, YYYY hh:mm A');
                                        // Provide a default empty object if observation is null or undefined
                                        // const observationValues = attend.observation ? Object.values(attend.observation) : [];

                                        // // Join observations into a single string if needed
                                        // const observationText = observationValues.length > 0 ? observationValues.join(', ') : 'No observations';
                                        const observation = attend.observation && Object.values(attend.observation);

                                        // Only render the observation if it exists and is not null or empty
                                        if (!observation || observation.length === 0 || observation[0] === null) {
                                            return null;
                                        }
                                        return (
                                            <div key={index}>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`${convertUTCtoIST(timestamp)} | ${attend.attended_username}`}
                                                        secondary={observation}
                                                    />
                                                </ListItem>
                                                {index < breakDownDetails.attendance.length - 1 && <Divider />}
                                            </div>
                                        );
                                    })}
                                </List>
                            )}
                        </Grid>
                    </Grid>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            Approver's Comment
                            <h4>{breakDownDetails.approvers[0].comment}</h4>
                        </Grid>
                    </Grid>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            Observation
                            <TextField
                                name="observation"
                                fullWidth
                                multiline
                                minRows={4}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <h4>Do you want to do root cause analysis?</h4>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={rootCause}
                                        name="enabled"
                                        color="primary"
                                        onClick={() => setrootCause(!rootCause)}
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box style={{ margin: '0 auto', maxWidth: '850px', marginBottom: "12px" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px" }}
                                startIcon={<NotInterestedIcon />}
                                onClick={() => navigate('/breakdown-management/pending-notes')}
                            >
                                Discard
                            </Button>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px" }}
                                startIcon={postLoading ? <CircularProgress size={20} /> : <CheckIcon />}
                                disabled={postLoading}
                                onClick={submitHandler}
                            >
                                {postLoading ? "Submiting" : "Submit"}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        {Object.keys(breakDownDetails.comments)
                            .filter(commentId => commentId !== 'user_names') // Filter out 'user_names'
                            .map((commentId) => {
                                const commentData = breakDownDetails.comments[commentId];
                                const userName = breakDownDetails.comments.user_names[commentId];

                                // Split the timestamp and comment
                                const [timestamp, comment] = commentData.split(': ');

                                // Format the date using dayjs
                                const formattedDate = dayjs(timestamp).format("DD MMM, YYYY hh:mm A");

                                return (
                                    <Grid item xs={12} sm={12} key={commentId}>
                                        Comments
                                        <h4>{convertUTCtoIST(timestamp)} - {comment} (by {userName})</h4>
                                    </Grid>
                                );
                            })
                        }
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default AddNotes;
